import type { Link } from '~/types'
import type { BreadcrumbListJsonLd, ListItemJsonLd } from './jsonLdTypes'

/**
 * Generates JSON-LD structured data for BreadcrumbList schema
 * @param items - Array of breadcrumb links
 * @param baseUrl - Base URL of the site (e.g., 'https://careum.ch')
 * @returns BreadcrumbList JSON-LD object or null if items invalid
 */
export function generateBreadcrumbJsonLd(items: Link[], baseUrl: string): BreadcrumbListJsonLd | null {
  if (!items || items.length === 0) {
    return null
  }

  const itemListElement: ListItemJsonLd[] = items.map((item, index) => {
    const position = index + 1
    const name = item.text || item.title || ''

    // Construct absolute URL
    const absoluteUrl = item.url.startsWith('http') ? item.url : `${baseUrl}${item.url}`

    return {
      '@type': 'ListItem',
      position,
      name,
      item: absoluteUrl,
    }
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  }
}
